export enum StorageKeys {
    FeedCallPageSelectedPenId = 'FeedCallPageSelectedPenId',
    FeedCallPagePenFilterByRation = 'FeedCallPagePenFilterByRation',
}
